import LegalLayout, { LegalSection } from "./LegalLayout";
import { LEGAL } from "../../lib/legal";

export default function AIDisclaimer() {
    return (
        <LegalLayout title="Disclaimer AI" version={LEGAL.aiDisclaimerVersion} testid="ai-disclaimer-page">
            <LegalSection>
                <p>
                    La piattaforma utilizza modelli di intelligenza artificiale per elaborare informazioni
                    e produrre analisi a supporto delle decisioni d&apos;investimento immobiliare. Il
                    presente documento chiarisce la natura e i limiti di tali output.
                </p>
            </LegalSection>

            <LegalSection title="1. Natura indicativa degli output">
                <p>
                    Analisi legale e urbanistica, valutazioni di mercato, &ldquo;Investment Score&rdquo;,
                    stime di ROI, offerta massima consigliata e ogni altro risultato generato
                    dall&apos;AI sono <strong>indicativi, probabilistici e non garantiti</strong>. Possono
                    contenere errori, omissioni o imprecisioni dovuti alla qualità dei dati di partenza o
                    ai limiti intrinseci dei modelli.
                </p>
            </LegalSection>

            <LegalSection title="2. Non è consulenza professionale">
                <p>
                    Gli output <strong>non costituiscono</strong> consulenza legale, notarile, finanziaria,
                    fiscale, tecnica o di investimento, né raccomandazione o sollecitazione
                    all&apos;acquisto. Non sostituiscono il parere di professionisti qualificati
                    (avvocati, notai, geometri/architetti, commercialisti, tecnici estimatori).
                </p>
            </LegalSection>

            <LegalSection title="3. Verifiche a carico dell'utente">
                <p>
                    Prima di partecipare a un&apos;asta o assumere decisioni economiche, l&apos;utente è
                    tenuto a verificare in autonomia tutte le informazioni rilevanti presso le fonti
                    ufficiali: perizia di stima, avviso e ordinanza di vendita, visure ipo-catastali,
                    regolarità urbanistica, stato di occupazione e oneri/gravami, presso il Tribunale
                    competente e i professionisti delegati.
                </p>
            </LegalSection>

            <LegalSection title="4. Limitazione di responsabilità">
                <p>
                    Nei limiti massimi consentiti dalla legge, il Fornitore non risponde di alcun danno,
                    perdita o mancato guadagno derivante dall&apos;affidamento sugli output dell&apos;AI.
                    Ogni decisione è assunta dall&apos;utente sotto la propria esclusiva responsabilità.
                </p>
            </LegalSection>
        </LegalLayout>
    );
}
